import { useState } from "react";
import { Modal } from "react-bootstrap";
import Spinner from "../../Components/Spinner";
import ErrorMessage from "../../Components/ErrorMessage";
import { useLanguage } from "../../Translations/LenguageContext";
import { MdCheck, MdOutlineCopyAll } from "react-icons/md";

const VerifyDomainModal = ({
    show,
    handleClose,
    data,
    fetchData,
    handleVerifyDomain,
    verifyContent,
    loadingVerify,
    setLoadingVerify,
    errorMessageVerify,
    setErrorMessageVerify,
}) => {
    const { t } = useLanguage();
    const [copiedField, setCopiedField] = useState(null);

    const handleCopy = async (field, value) => {
        if (!value) return;

        try {
            await navigator.clipboard.writeText(value);
            setCopiedField(field);

            setTimeout(() => {
                setCopiedField((current) =>
                    current === field ? null : current
                );
            }, 3000);
        } catch (error) {
            console.error("Failed to copy to clipboard:", error);
        }
    };

    const closeModal = () => {
        handleClose();
        fetchData();
        setLoadingVerify(false);
        setErrorMessageVerify({ message: "", display: false });
        setCopiedField(null);
    };

    return (
        <Modal show={show} centered onHide={closeModal}>
            <div className="modal_header">
                <p className="modal_header_title">{t.properties.verify_domain_title}</p>
            </div>

            <div className="modal_main_cont">
                <div className="modal_profile_input_cont">
                    <div className="label_input">
                        <label className="input_label">
                            {t.properties.type}
                        </label>
                        <p className="register_form_first register_form_first_disabled fade-in">
                            TXT
                            <button
                                type="button"
                                className="tag_header_btn"
                                onClick={() => handleCopy("type", "TXT")}
                                aria-label="Copy record type"
                            >
                                {copiedField === "type" ? (
                                    <MdCheck />
                                ) : (
                                    <MdOutlineCopyAll />
                                )}
                            </button>
                        </p>
                    </div>

                    <div className="label_input">
                        <label className="input_label">
                            {t.name}
                        </label>
                        <p className="register_form_first register_form_first_disabled fade-in">
                            {data?.domain_record_name}
                            <button
                                type="button"
                                className="tag_header_btn"
                                onClick={() =>
                                    handleCopy("name", data?.domain_record_name)
                                }
                                aria-label="Copy record name"
                            >
                                {copiedField === "name" ? (
                                    <MdCheck />
                                ) : (
                                    <MdOutlineCopyAll />
                                )}
                            </button>
                        </p>
                    </div>

                    <div className="label_input">
                        <label className="input_label">
                            TTL
                        </label>
                        <p className="register_form_first register_form_first_disabled fade-in">
                            30 mins
                        </p>
                    </div>



                    <div className="label_input">
                        <label className="input_label">
                            {t.properties.data}
                        </label>
                        <p className="register_form_first register_form_first_disabled fade-in">
                            {data?.domain_record_key}
                            <button
                                type="button"
                                className="tag_header_btn"
                                onClick={() =>
                                    handleCopy("data", data?.domain_record_key)
                                }
                                aria-label="Copy TXT record value"
                            >
                                {copiedField === "data" ? (
                                    <MdCheck />
                                ) : (
                                    <MdOutlineCopyAll />
                                )}
                            </button>
                        </p>
                    </div>

                    <p className="domain_verify_title">{t.properties.provider_message}</p>
                    {loadingVerify ? (
                        <div className="domain_verify_loading">
                        </div>
                    ) : (
                        <div className="domain_verify_cont">
                            {verifyContent?.verification_status === "VERIFIED" ? (
                                <p className="domain_verify fade-in status_ok">
                                    {verifyContent.message}
                                </p>
                            ) : verifyContent?.verification_status === "PENDING" ? (
                                <p className="domain_verify fade-in status_warn">
                                    {verifyContent.message}
                                </p>
                            ) : (
                                <p className="domain_verify fade-in status_err">
                                    {verifyContent.message}
                                </p>
                            )}
                        </div>
                    )}

                    <p className="warning_source_message fade-in">
                        {t.properties.verify_domain_own_warn}
                        <br/>
                        {t.properties.domain} {data?.domain}
                    </p>
                </div>
            </div>

            <div className="modal_footer">
                <div className="modal_footer_err_cont">
                    <ErrorMessage err={errorMessageVerify} />
                </div>

                <div className="modal_footer_btn_cont">
                    <button
                        className="modale_save_btn"
                        onClick={handleVerifyDomain}
                        disabled={loadingVerify}
                    >
                        {loadingVerify ? <Spinner loading={true} /> : t.properties.verify_domain_btn}
                    </button>

                    <button
                        className="modale_close_btn"
                        onClick={closeModal}
                    >
                        {t.close}
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default VerifyDomainModal;